module.exports = __webpack_public_path__ + "static/media/eigenerAnwalt.93a3378c.svg";